/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener( 'DOMContentLoaded', () => {


	//main-carousel .splide__list
	document.querySelectorAll('.carousel').forEach(carousel => {
		let modal = carousel.querySelector(".modal");
		let modalImg = carousel.querySelector(".modal-content");

		carousel.querySelector('#main-carousel .splide__list').addEventListener('click', (e) => {
			modal.style.display = "block";
			modalImg.src = carousel.querySelector('#main-carousel .splide__list').querySelector('.splide__slide.is-active img').src;
			modalImg.alt = carousel.querySelector('#main-carousel .splide__list').querySelector('.splide__slide.is-active img').alt;
		});

		// Get the <span> element that closes the modal
		let close = carousel.querySelector(".close");

		// When the user clicks on <span> (x), close the modal
		close.onclick = function() {
		modal.style.display = "none";
	}
	});



});
